import React from 'react'
import Layout from '../components/Layout/Layout'
import config from '../utils/siteConfig'
import { AiApproach } from '../components/AiApproach'

// This page is hand-authored rather than Contentful-driven, so it does not go
// through <PageHead/> like the templates do - which is why it had no favicon:
// that <link rel="icon"> lives in PageHead, and gatsby-plugin-manifest is not
// configured in gatsby-config.js, so nothing else injects one. The tag set
// below mirrors PageHead's for consistency.
const PAGE_PATH = '/ai-services/'
const TITLE = 'AI Services - good for your people, honest about the planet'
const DESCRIPTION =
  'LFCA helps teams adopt AI with people, not to them - building the governance and processes that are better for your people, the planet and your bottom line.'
// og:image must be absolute, and a jpg: LinkedIn in particular is unreliable
// with webp share images.
const OG_IMAGE = `${config.siteUrl}/images/ai-services/og-ai-services.jpg`
const PAGE_URL = `${config.siteUrl}${PAGE_PATH}`

export function Head() {
  return (
    <>
      <title>{TITLE}</title>
      <link href={config.favicon} rel="icon" />
      <meta content={DESCRIPTION} name="description" />
      <meta content={OG_IMAGE} name="image" />

      {/* OpenGraph */}
      <meta content="website" property="og:type" />
      <meta content={TITLE} property="og:title" />
      <meta content={DESCRIPTION} property="og:description" />
      <meta content={PAGE_URL} property="og:url" />
      <meta content={OG_IMAGE} property="og:image" />
      <meta content="1200" property="og:image:width" />
      <meta content="630" property="og:image:height" />
      <meta
        content="AI that’s good for your people, and honest about the planet."
        property="og:image:alt"
      />

      {/* Twitter */}
      <meta content="summary_large_image" name="twitter:card" />
      <meta content={config.userTwitter || ''} name="twitter:creator" />
      <meta content={TITLE} name="twitter:title" />
      <meta content={DESCRIPTION} name="twitter:description" />
      <meta content={OG_IMAGE} name="twitter:image" />
    </>
  )
}

// hasStickyComponent: the services bar uses `position: sticky`. The default
// template's `.siteContent` sets `overflow-x: hidden`, which per spec forces
// `overflow-y` to compute to `auto` and breaks sticky against the viewport;
// this flag switches that back so the bar pins correctly.
const AiServicesPage = ({ location }) => (
  <Layout location={location} inverse={false} hasStickyComponent>
    <AiApproach />
  </Layout>
)

export default AiServicesPage
